import { Loading, RenderView, usePublicBlockQueryShowBySlug } from "@dgs/core";
import { FC } from "react";
import { useParams } from "react-router";

export const BlockPage: FC = () => {
	const { slug = "" } = useParams();
	const { block, isLoading } = usePublicBlockQueryShowBySlug(slug);

	if (isLoading) {
		return <Loading />;
	}
	return block && <RenderView block={block} />;
};
